import React, { Component } from 'react';
import ReactPixel from 'react-facebook-pixel';

export default class Screen extends Component {
  componentDidMount() {
    // console.debug('componentDidMount ::', this.props);
    ReactPixel.pageView();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  render() {
    const { Page } = this.props;
    return (
      <div>
        <Page {...this.props} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Page.js